import { useNavigate } from "react-router-dom";
import { MobileMenuItem } from "./MobileMenuItem";

interface MobileMenuProps {
  isOpen: boolean;
  onContactUs: () => void;
}

export function MobileMenu({ isOpen, onContactUs }: MobileMenuProps) {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="mobile-menu">
      <MobileMenuItem label="Log In" className="login-button" />
      <MobileMenuItem label="Contact Us" className="contactus-button" onClick={onContactUs} />
      <MobileMenuItem label="Support" className="support-button" />
      <MobileMenuItem
        label="Legal"
        className="legal-button"
        onClick={() => navigate("/terms-of-service")}
      />
    </div>
  );
}
